import { SubScriptionTable } from "../../component/SubScriptionTable";

export default function SubScriptionManagementPage() {
  return <SubScriptionTable />;
}